import api from "../api.js";

//GET COMPANY
export const getCompany = async () => {
  try {
    const response = await api.get("/company");
    const data = response.data;

    // Asegúrate de acceder a la propiedad "company"
    const companyData = data.company || {};

    const normalizeBoolean = (value) => {
      if (typeof value === "boolean") return value;
      if (typeof value === "number") return value === 1;
      if (typeof value === "string") return value === "1" || value.toLowerCase() === "true";
      return false;
    };
    
    // Crear un objeto que incluya TODOS los campos de la API sin filtrar
    // Solo normalizar campos booleanos específicos cuando sea necesario
    const processedData = {
      ...companyData, // Incluir TODOS los campos que vienen de la API
      // Solo normalizar campos específicos que sabemos que pueden venir como números/strings
      hideCommunicationStateLog: companyData.hideCommunicationStateLog !== undefined 
        ? normalizeBoolean(companyData.hideCommunicationStateLog) 
        : companyData.hideCommunicationStateLog
    };

    // NO aplicar valores por defecto - guardar exactamente lo que viene de la API
    // Los valores por defecto solo se aplicarán en el frontend cuando sea necesario

    return processedData;
  } catch (error) {
    if (error?.response) {
      const apiError = new Error("Error al obtener la empresa");
      apiError.status = error.response.status;
      apiError.data = error.response.data;
      throw apiError;
    }

    throw new Error("Error al obtener la empresa");
  }
};

//update COMPANY
export const updateCompany = async (company) => {
  try {
    const response = await api.post("/company", company);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error("Error en el login");
  }
};
export const setVisit = async () => {
  try {
    const response = await api.post("/company/visit");
    return response.data;
  } catch (error) {
    throw error.response
        ? error.response.data
        : new Error("Error al registrar la visita");
  }
};

export default {
  getCompany,
  updateCompany,
  setVisit,
};